/** How far in the viewer zooms. */
export const MIN_SCALE = 1;
export const MAX_SCALE = 5;
/** A double tap zooms to this, or back out. */
export const DOUBLE_TAP_SCALE = 2.5;

export const RESET = { scale: 1, x: 0, y: 0 };

/**
 * Keeps the image covering the stage: zoomed in, its edges can't be dragged inside the stage's edges; at 1× it
 * sits centered. Offsets are from the stage's center.
 *
 * @param {{scale: number, x: number, y: number}} view
 * @param {{width: number, height: number}} image  the image's size at 1×
 * @param {{width: number, height: number}} stage
 */
export function clampView(view, image, stage) {
  const scale = Math.min(Math.max(view.scale, MIN_SCALE), MAX_SCALE);
  const limitX = Math.max(0, (image.width * scale - stage.width) / 2);
  const limitY = Math.max(0, (image.height * scale - stage.height) / 2);
  return {
    scale,
    x: Math.min(Math.max(view.x, -limitX), limitX),
    y: Math.min(Math.max(view.y, -limitY), limitY),
  };
}

/**
 * Zooms by `factor` keeping `point` (relative to the stage's center) fixed under the finger or cursor.
 */
export function zoomAt(view, factor, point, image, stage) {
  const scale = Math.min(Math.max(view.scale * factor, MIN_SCALE), MAX_SCALE);
  const ratio = scale / view.scale;
  return clampView({
    scale,
    x: point.x - (point.x - view.x) * ratio,
    y: point.y - (point.y - view.y) * ratio,
  }, image, stage);
}
